<template>
  <DashboardVideo />
  <div class="container d-flex align-items-center justify-content-center z-2">
    <div class="row mobile align-content-between g-0">
      <div class="col-12 ps-3 pe-3 d-flex align-items-center justify-content-between theme-header">
        <router-link :to="{
          name: componentAdmin
        }" class="btn-back opacity-0">
        </router-link>
        <img src="/img/ui-theme/logo.png" class="logo" />

        <button class="btn" type="button" 
          aria-controls="offcanvasRight">
          <!-- <img src="/img/ui-theme/contact-icon-rev.svg" alt="Fullscreen"> -->
        </button>
      </div>

      <div class="col-12 d-flex align-items-center justify-content-center z-2">
        <div class="row g-0">
          <div class="col-12">
            <router-link :to="{
                name: 'VideoView',
                params: {
                  guid: 'b4b49ce4-b25a-4d91-836c-3e33e5031e62',
                  collectionId: '269303'
                }
              }" class="btn-theme-menu mb-2">
              Masterplan Teaser
            </router-link>
            <router-link :to="{
                name: 'VideoView',
                params: {
                  guid: '8bb8c95e-7266-4c8b-b809-0b8af13c01ae',
                  collectionId: '269303'
                }
              }" class="btn-theme-menu mb-2">
              Landmark Walk Through
            </router-link>
            <a href="/asset/landmark-virtual-tour/virtual-tour/view/1" class="btn-theme-menu mb-2">
              Landmark Virtual Tour
            </a>
            
          </div>
        </div>
      </div>
      <div class="col-12 d-flex ">
       
      </div>
    </div>
  </div>
  <OffCanvas />
</template>

<script>
import DashboardVideo from "@/components/DashboardVideo.vue";
import OffCanvas from "@/components/OffCanvas.vue";
import global from '../global'
import BunnyNetService from "@/services/BunnyNetService.js";
import { unslugify } from "unslugify";
import sortArray from 'sort-array'

export default {
  name: "DashboardHome",
  components: {
    DashboardVideo,
    OffCanvas
  },
  data() {
    return {
      assetTypes: null,
      componentName: "AssetType",
      componentAdmin: "Admin",
      folderStructure: encodeURIComponent(this.theme.devFolder + '/assets/'),
      brochureUrl: "https://florian.metaluxe.com.au/brochure/MCO0024_Master%20brochure%2048pp_320x240_V9%20(2).pdf"
    }
  },
  created() {
    BunnyNetService.getFolders(this.folderStructure)
      .then(response => {
        // Remap array
        console.log(response)
        const menuItems = response.data.map((item) => {
          return {
            Guid: item.Guid,
            ObjectName: unslugify(item.ObjectName),
            LinkName: item.ObjectName,
            ComponentName: this.componentName,
            Path: item.Path,
            IsDirectory: item.IsDirectory,
            StorageZoneName: item.StorageZoneName
          };
        });

        const customMenu = sortArray(menuItems, {
          by: ['LinkName'],
          order: 'LinkName',
          customOrders: {
            LinkName: this.theme.assetsMenuOrder
          }
        })

        this.assetTypes = customMenu
      })
      .catch(error => {
        console.log(error)
      })
  },
  setup() {
    const { theme } = global

    return {
      theme
    }
  }
};
</script>
